export default __webpack_public_path__ + "static/media/StandingRock.c9319f8b.pdf";